<template>
  <a-card :bordered="false" :headStyle="{ fontSize: '18px' }">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['flowId', 'flowName']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="flowId"
      :leftSpace="20"
      requestType="post"
      :requestPromise="loadDataList"
    >
      <a-space slot="operation" style="margin-bottom: 16px">
        <a-button type="primary" icon="plus" @click="onAddEvent">新建</a-button>
        <a @click="onSettingEvent">高级设置</a>
      </a-space>
      <a-form-item slot="flowId" label="审批ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.flowId" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <a-form-item slot="flowName" label="审批流" v-bind="searchItemLayout">
        <a-input v-model="queryParams.invoiceId" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <template slot="status" slot-scope="rowItem">
        {{ rowItem.record.status == 1 ? '启用' : '禁用' }}
      </template>
      <a-space slot="action" slot-scope="rowItem">
        <!--        <a @click="toDeleteEvent(rowItem.record)">删除</a>-->
        <a-popconfirm
          title="是否要删除当前审批？"
          @confirm="toDeleteEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
        <a @click="onSwitchStatus(rowItem.record)">{{ rowItem.record.status == 1 ? '禁用' : '启用' }}</a>
      </a-space>
    </search-page-view>
    <FlowCreatorDialog
      v-if="showFlowCreatorDialog"
      :value="enterpriseId"
      :item="selectItem"
      @cancel="showFlowCreatorDialog=false"
      @ok="refreshData(true)"
    ></FlowCreatorDialog>
    <AdvancedProcessSettingsDialog
      v-if="showAdvancedProcessSettingsDialog"
      :enterpriseId="enterpriseId"
      @cancel="showAdvancedProcessSettingsDialog=false"
    ></AdvancedProcessSettingsDialog>
  </a-card>
</template>
<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import employeeOptions from '@/views/platform/employeeVerification/mixins/employeeMixins'
import FlowCreatorDialog from '@/views/platform/employeeVerification/dialog/FlowCreatorDialog.vue'
import AdvancedProcessSettingsDialog
  from '@/views/platform/employeeVerification/dialog/AdvancedProcessSettingsDialog.vue'

export default {
  name: 'ApprovalWorkflow',
  mixins: [searchForm, employeeOptions],
  components: {
    FlowCreatorDialog: FlowCreatorDialog,
    AdvancedProcessSettingsDialog: AdvancedProcessSettingsDialog

  },
  data() {
    return {
      showAdvancedProcessSettingsDialog: false,
      showFlowCreatorDialog: false,
      selectItem: undefined,
      columns: [
        {
          title: '审批ID',
          dataIndex: 'flowId',
          width: '100px'
        },
        {
          title: '审批流',
          dataIndex: 'flowName'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '120px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '160px'
        },

        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {}
    }
  },
  watch: {
    'enterpriseId': function(val) {
      if (this.enterpriseId) {
        this.refreshData(true)
      }
    }
  },
  mounted() {

  },
  methods: {
    loadDataList(params) {
      return this.getHttpServices().getMemberAuthService().post('member/v3/auth/getApprovalFlowList', { enterpriseId: this.enterpriseId, ...params })
    },
    refreshData(reset) {
      this.$refs.pageList.refresh(reset)
    },
    onSwitchStatus(item) {
      const params = {
        flowId: item.flowId,
        status: String(item.status) === '1' ? 2 : 1
      }
      const url = 'member/v3/auth/updateAuthApprovalFlowStatus'
      this.getHttpServices().getMemberAuthService().post(url, params)
        .then(res => {
          this.refreshData(false)
          this.$message.success('操作成功！')
        })
        .catch(err => {
          if (err && err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    },
    toDeleteEvent(item) {
      const url = 'member/v3/auth/removeAuthApprovalFlow'
      this.getHttpServices().getMemberAuthService().post(url, { flowId: item.flowId })
        .then(res => {
          this.refreshData(true)
          this.$message.success('删除成功')
        })
        .catch(err => {
          if (err && err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('删除失败，请重试！')
          }
          console.error(err)
        })
    },
    onAddEvent() {
      this.selectItem = undefined
      this.showFlowCreatorDialog = true
    },
    onSettingEvent() {
      this.showAdvancedProcessSettingsDialog = true
    }

  }
}
</script>
<style scoped lang="less">

</style>